<template>
  <div class="reset-password-modal">
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <el-form
        label-position="top"
        :model="resetPasswordForm"
        status-icon
        :rules="rules"
        ref="resetPasswordForm"
        label-width="130px"
        class="demo-ruleForm"
        :hide-required-asterisk="true"
      >
        <el-form-item label="New Password" prop="newPassword">
          <el-input
            type="password"
            show-password
            v-model="resetPasswordForm.newPassword"
            autocomplete="off"
          ></el-input>
        </el-form-item>

        <el-form-item label="Confirm Password" prop="confirmPassword">
          <el-input
            type="password"
            show-password
            v-model="resetPasswordForm.confirmPassword"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <div class="footer">
          <el-form-item>
            <el-button
              class="btn-secondary cancel"
              type="info"
              @click="handleClose()"
              @keypress="handleClose()"
            >
              Cancel
            </el-button>
            <el-button
              class="btn-secondary submit"
              :loading="loading"
              type="info"
              @click="resetPassword('resetPasswordForm')"
              @keypress="resetPassword('resetPasswordForm')"
            >
              Submit
            </el-button>
          </el-form-item>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import ApiSSO from '../../lib/ApiSSO';

export default {
  name: 'ResetPasswordModal',
  components: {},
  props: ['showModal', 'title'],
  data() {
    const validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please input the password again'));
      } else if (value !== this.resetPasswordForm.newPassword) {
        callback(new Error("Two inputs don't match!"));
      } else {
        callback();
      }
    };
    return {
      dialogVisible: this.showModal,
      loading: false,
      resetPasswordForm: {
        newPassword: '',
        confirmPassword: '',
      },
      rules: {
        newPassword: [
          {
            type: 'string',
            required: true,
            message: 'Please enter new password.',
            trigger: 'blur',
          },
        ],
        confirmPassword: [
          {
            type: 'string',
            required: true,
            message: 'Please confirm password.',
            validator: validatePass2,
          },
        ],
      },
    };
  },
  watch: {
    dialogVisible(val) {
      if (!val) {
        this.$root.$emit('closeModal');
      }
    },
  },
  computed: {
    ...mapState(['user']),
  },
  methods: {
    handleClose() {
      this.$root.$emit('closeModal');
    },
    resetPassword(formName) {
      this.loading = true;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          return this.sendReset();
        }
        this.loading = false;
        return false;
      });
    },
    sendReset() {
      const data = {
        id: this.user.id,
        password: this.resetPasswordForm.newPassword,
      };

      ApiSSO.put('/users', data)
        .then((r) => {
          if (r) {
            if (r.success) {
              this.loading = false;
              this.dialogVisible = false;
              this.resetForm('resetPasswordForm');
            }
          }
        })
        .catch((e) => {
          console.log(e);
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
  mounted() {
  },
};
</script>

<style lang="scss">
.reset-password-modal {
  .footer {
    height: 80px;
    background: #FFFFFF;
    border-top: 1px solid #E5E5E5;
    margin-top: 50px;
    display: flex;
    justify-content: end;
    padding-top: 20px;

    .el-form-item__content {
      display: flex;
    }

    .cancel {
      width: 96px;
      height: 36px;
      background: #F1F1F1;
      border-radius: 4px;
      border: 0;
      color: #363738;
    }

    .submit {
      width: 134px;
      height: 36px;
      background: #3FB5E5;
      border-radius: 4px;
      border: 0;
      color: #FFFFFF;
    }
  }
}
</style>
